
import { schema } from "./types";
import { IAutomationAppComponent } from "../../../types";
import EmissionsChart from "./EmmissionsChart";
import { MdCo2 } from "react-icons/md";
import { TimeRange } from "../PortfolioEnergyChart/types";
import { OperatorPanel } from "./OperatorPanel";
import ConfigurationPanel from "./ConfigurationPanel";


export const App : IAutomationAppComponent = {
    schema: schema,
    supportsProcessPanel: false,
    Icon: MdCo2,
    OverviewPanel: EmissionsChart,
    OperatorPanel: OperatorPanel,
    ConfigurationPanel: ConfigurationPanel,
    createConfig: {
        group: 'ReportsAndStatistics',
        name: "Emissions Chart",
        description: "Portfolio Emissions Chart",
        panel: EmissionsChart,
        defaultState: { timeRange: TimeRange.YearToDate },
        defaultProperties: [ ]
    },
}